<template>
  <div>
    <section>
      <div>
        <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
        <!-- <loading
          :active.sync="isLoading"
          loader="spinner"
          color="#36304a"
          :width="70"
        ></loading> -->
      </div>

      <b-card class="mainCardBG">
        <b-navbar toggleable="lg" type="dark" variant="info">
          <b-navbar-brand style="padding: 0.475rem 1rem">
            <h3>Reporting</h3>
          </b-navbar-brand>
          <b-button-group size="sm" class="ml-1">
            <!-- <b-button variant="primary">Analytics</b-button> -->
            <b-button variant="outline-info" @click="previousDash"
              >Analytics</b-button
            >
          </b-button-group>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-form></b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <md-tabs class="md-transparent" md-alignment="fixed">
          <md-tab id="tab-home" md-label="Enquiry Analysis">
            <b-card class="formCard">
              <div class="tree" style="margin-top: -20px">
                <ul>
                  <li>
                    <a @click="goToDetails('allEnq')"
                      >Total Enquiry
                      <br />
                      {{ enqDataCount[0].totalEnquiry }}
                    </a>
                    <ul>
                      <li>
                        <ul>
                          <li>
                            <a @click="goToDetails('E1')"
                              >Enquiry From Existing Clients
                              <br />
                              {{ enqDataCount[0].ExistClientEnquiry }}
                            </a>
                            <ul>
                              <li>
                                <a @click="goToDetails('E11')"
                                  >Sea Shipment
                                  <br />
                                  {{ enqDataCount[0].ExistClientSeaEnquiry }}
                                </a>
                                <ul>
                                  <li>
                                    <a @click="goToDetails('E11Export')"
                                      >Sea Export
                                      <br />
                                      {{
                                        enqDataCount[0]
                                          .ExistClientSeaExportEnquiry
                                      }}
                                    </a>
                                    <ul>
                                      <li>
                                        <a @click="goToDetails('E11ExportTPT')"
                                          >TPT
                                          <br />
                                          {{
                                            enqDataCount[0]
                                              .ExistClientTPTSeaExportEnquiry
                                          }}
                                        </a>
                                      </li>
                                      <li>
                                        <a @click="goToDetails('E11ExportFF')"
                                          >FF
                                          <br />
                                          {{
                                            enqDataCount[0]
                                              .ExistClientFFSeaExportEnquiry
                                          }}
                                        </a>
                                      </li>
                                      <li>
                                        <a @click="goToDetails('E11ExportCC')"
                                          >CC
                                          <br />
                                          {{
                                            enqDataCount[0]
                                              .ExistClientCCSeaExportEnquiry
                                          }}
                                        </a>
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <a @click="goToDetails('E11Import')"
                                      >Sea Import
                                      <br />
                                      {{
                                        enqDataCount[0]
                                          .ExistClientSeaImportEnquiry
                                      }}
                                    </a>
                                    <ul>
                                      <li>
                                        <a @click="goToDetails('E11ImportTPT')"
                                          >TPT
                                          <br />
                                          {{
                                            enqDataCount[0]
                                              .ExistClientTPTSeaImportEnquiry
                                          }}
                                        </a>
                                      </li>
                                      <li>
                                        <a @click="goToDetails('E11ImportFF')"
                                          >FF
                                          <br />
                                          {{
                                            enqDataCount[0]
                                              .ExistClientFFSeaImportEnquiry
                                          }}
                                        </a>
                                      </li>
                                      <li>
                                        <a @click="goToDetails('E11ImportCC')"
                                          >CC
                                          <br />
                                          {{
                                            enqDataCount[0]
                                              .ExistClientCCSeaImportEnquiry
                                          }}
                                        </a>
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <a @click="goToDetails('E12')"
                                  >Air Shipment
                                  <br />
                                  {{ enqDataCount[0].ExistClientAirEnquiry }}
                                </a>
                                <ul>
                                  <li>
                                    <a @click="goToDetails('E12Export')"
                                      >Air Export
                                      <br />
                                      {{
                                        enqDataCount[0]
                                          .ExistClientAirExportEnquiry
                                      }}
                                    </a>
                                    <ul>
                                      <li>
                                        <a @click="goToDetails('E12ExportTPT')"
                                          >TPT
                                          <br />
                                          {{
                                            enqDataCount[0]
                                              .ExistClientTPTAirExportEnquiry
                                          }}
                                        </a>
                                      </li>
                                      <li>
                                        <a @click="goToDetails('E12ExportFF')"
                                          >FF
                                          <br />
                                          {{
                                            enqDataCount[0]
                                              .ExistClientFFAirExportEnquiry
                                          }}
                                        </a>
                                      </li>
                                      <li>
                                        <a @click="goToDetails('E12ExportCC')"
                                          >CC
                                          <br />
                                          {{
                                            enqDataCount[0]
                                              .ExistClientCCAirExportEnquiry
                                          }}
                                        </a>
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <a @click="goToDetails('E12Import')"
                                      >Air Import
                                      <br />
                                      {{
                                        enqDataCount[0]
                                          .ExistClientAirImportEnquiry
                                      }}
                                    </a>
                                    <ul>
                                      <li>
                                        <a @click="goToDetails('E12ImportTPT')"
                                          >TPT
                                          <br />
                                          {{
                                            enqDataCount[0]
                                              .ExistClientTPTAirImportEnquiry
                                          }}
                                        </a>
                                      </li>
                                      <li>
                                        <a @click="goToDetails('E12ImportFF')"
                                          >FF
                                          <br />
                                          {{
                                            enqDataCount[0]
                                              .ExistClientFFAirImportEnquiry
                                          }}
                                        </a>
                                      </li>
                                      <li>
                                        <a @click="goToDetails('E12ImportCC')"
                                          >CC
                                          <br />
                                          {{
                                            enqDataCount[0]
                                              .ExistClientCCAirImportEnquiry
                                          }}
                                        </a>
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </li>

                          <li>
                            <a @click="goToDetails('L2')"
                              >Enquiry From Leads
                              <br />
                              {{ enqDataCount[0].LeadClientEnquiry }}
                            </a>
                            <ul>
                              <li>
                                <a @click="goToDetails('L21')"
                                  >Sea Shipment
                                  <br />
                                  {{ enqDataCount[0].LeadSeaEnquiry }}
                                </a>
                                <ul>
                                  <li>
                                    <a @click="goToDetails('L21Export')"
                                      >Sea Export
                                      <br />
                                      {{ enqDataCount[0].LeadSeaExportEnquiry }}
                                    </a>
                                    <ul>
                                      <li>
                                        <a @click="goToDetails('L21ExportTPT')"
                                          >TPT
                                          <br />
                                          {{
                                            enqDataCount[0]
                                              .LeadTPTSeaExportEnquiry
                                          }}
                                        </a>
                                      </li>
                                      <li>
                                        <a @click="goToDetails('L21ExportFF')"
                                          >FF
                                          <br />
                                          {{
                                            enqDataCount[0]
                                              .LeadFFSeaExportEnquiry
                                          }}
                                        </a>
                                      </li>
                                      <li>
                                        <a @click="goToDetails('L21ExportCC')"
                                          >CC
                                          <br />
                                          {{
                                            enqDataCount[0]
                                              .LeadCCSeaExportEnquiry
                                          }}
                                        </a>
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <a @click="goToDetails('L21Import')"
                                      >Sea Import
                                      <br />
                                      {{ enqDataCount[0].LeadSeaImportEnquiry }}
                                    </a>
                                    <ul>
                                      <li>
                                        <a @click="goToDetails('L21ImportTPT')"
                                          >TPT
                                          <br />
                                          {{
                                            enqDataCount[0]
                                              .LeadTPTSeaImportEnquiry
                                          }}
                                        </a>
                                      </li>
                                      <li>
                                        <a @click="goToDetails('L21ImportFF')"
                                          >FF
                                          <br />
                                          {{
                                            enqDataCount[0]
                                              .LeadFFSeaImportEnquiry
                                          }}
                                        </a>
                                      </li>
                                      <li>
                                        <a @click="goToDetails('L21ImportCC')"
                                          >CC
                                          <br />
                                          {{
                                            enqDataCount[0]
                                              .LeadCCSeaImportEnquiry
                                          }}
                                        </a>
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <a @click="goToDetails('L22')"
                                  >Air Shipment
                                  <br />
                                  {{ enqDataCount[0].LeadAirEnquiry }}
                                </a>
                                <ul>
                                  <li>
                                    <a @click="goToDetails('L22Export')"
                                      >Air Export
                                      <br />
                                      {{ enqDataCount[0].LeadAirExportEnquiry }}
                                    </a>
                                    <ul>
                                      <li>
                                        <a @click="goToDetails('L22ExportTPT')"
                                          >TPT
                                          <br />
                                          {{
                                            enqDataCount[0]
                                              .LeadTPTAirExportEnquiry
                                          }}
                                        </a>
                                      </li>
                                      <li>
                                        <a @click="goToDetails('L22ExportFF')"
                                          >FF
                                          <br />
                                          {{
                                            enqDataCount[0]
                                              .LeadFFAirExportEnquiry
                                          }}
                                        </a>
                                      </li>
                                      <li>
                                        <a @click="goToDetails('L22ExportCC')"
                                          >CC
                                          <br />
                                          {{
                                            enqDataCount[0]
                                              .LeadCCAirExportEnquiry
                                          }}
                                        </a>
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <a @click="goToDetails('L22Import')"
                                      >Air Import
                                      <br />
                                      {{ enqDataCount[0].LeadAirImportEnquiry }}
                                    </a>
                                    <ul>
                                      <li>
                                        <a @click="goToDetails('L22ImportTPT')"
                                          >TPT
                                          <br />
                                          {{
                                            enqDataCount[0]
                                              .LeadTPTAirImportEnquiry
                                          }}
                                        </a>
                                      </li>
                                      <li>
                                        <a @click="goToDetails('L22ImportFF')"
                                          >FF
                                          <br />
                                          {{
                                            enqDataCount[0]
                                              .LeadFFAirImportEnquiry
                                          }}
                                        </a>
                                      </li>
                                      <li>
                                        <a @click="goToDetails('L22ImportCC')"
                                          >CC
                                          <br />
                                          {{
                                            enqDataCount[0]
                                              .LeadCCAirImportEnquiry
                                          }}
                                        </a>
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </b-card>
          </md-tab>
          <md-tab id="tab-pages" md-label="Sales Execution Reports">
            <viewBilling></viewBilling>
          </md-tab>
        </md-tabs>

        <!-- </b-tab>
                <b-tab title="Sales Execution" @click="gotoSalesReport"></b-tab>
        </b-tabs>-->
        <!-- </b-card> -->
      </b-card>

      <!-- FF Starts Here -->
      <!-- TPT Ends Here -->
    </section>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import viewBilling from "./salesReports.vue";

import {
  globalPermissionStatus,
  GlobalContainerValid,
} from "../../../helper/collection";

export default {
  beforeMount() {
    this.$store.dispatch("setCurrentRoute", "/dashboard");
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != "" &&
      this.$sessionsStorage.get("departmentName") != undefined &&
      this.$sessionsStorage.get("departmentName") != "" &&
      this.$sessionsStorage.get("designation") != undefined &&
      this.$sessionsStorage.get("designation") != ""
    ) {
      this.getData();
    } else {
      this.$sessionsStorage.set("loginId", "");
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  // <router-link to @click.native="$router.push('/dashboard/dashboardReportsDetails/500')">500</router-link>
  data() {
    return {
      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      tabIndex: 0,
      docURL: URL_BASE_DOC,
      enqDataCount: [],
      execDataCount: [],
      dateRangeEnq: "",
      isLoading: "",
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      consoBooking: [],
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    viewBilling,
  },

  computed: {
    buttonDisable() {
      return this.mainModal.ffClientStatus == "2" ||
        this.mainModal.ffExpireStatus == "1"
        ? true
        : false;
    },
  },
  watch: {
    // containerNo: {
    //   handler(newVal, oldVal) {
    //     let newCon = this.containerNo.toUpperCase();
    //     this.containerNo = newCon;
    //   },
    //   deep: true
    // }

    shipModal: {
      handler: function (newVal, oldVal) {
        if (
          this.shipModal.shippingId != "" &&
          this.shipModal.ffShippingWiseId == ""
        ) {
          let arrayDum = this.ffShipArry.filter((x) => {
            return x.shippingId == this.shipModal.shippingId;
          });

          if (arrayDum.length > 0) {
            this.alert.content = arrayDum[0].shippingLine + " Already Exists";
            this.$refs["addPopAlready"].open();

            return false;
          }
        }
      },

      deep: true,
    },
  },
  methods: {
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ["bg-primary", "text-light"];
      } else {
        return ["bg-light", "text-info"];
      }
    },
    gotoSalesReport() {
      this.$router.push({
        path: "/dashboard/dashboardReportsExecList",
      });
    },
    goToDetails(id) {
      if (this.dateRangeEnq != "") {
        let todayDate = new Date(this.dateRangeEnq[0]);
        console.log(todayDate);
        //  return false;
        this.$router.push({
          path: "/dashboard/dashboardReportsDetails/" + id + "/" + todayDate,
        });
      } else {
        this.$router.push({
          path: "/dashboard/dashboardReportsDetails/" + id,
        });
      }
    },
    onConfirmDateRangeEq() {
      this.getData();
    },
    previousDash() {
      window.history.go(-1);
    },

    getData() {
      this.isLoading = true;
      let payload = {
        assignmentNo: "assignmentNo",
        fromDateRngEnq: this.dateRangeEnq[0],
        toDateRngEnq: this.dateRangeEnq[1],
      };
      console.log(payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_EmpDashboard/getDashboardReports.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.enqDataCount.length > 0) {
              this.enqDataCount = data.enqDataCount;
            } else {
              this.enqDataCount = [];
            }
            if (data.execDataCount.length > 0) {
              this.execDataCount = data.execDataCount;
            } else {
              this.execDataCount = [];
            }

            this.isLoading = false;
            // this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style scoped>
.formCard {
  border: none !important;
}
td {
  text-align: center !important ;
  /* min-width: 50px !important ;
  padding: 3px !important; */
}
.table-bordered > thead > tr > th,
.table-bordered > tbody > tr > th,
.table-bordered > tfoot > tr > th,
.table-bordered > thead > tr > td,
.table-bordered > tbody > tr > td,
.table-bordered > tfoot > tr > td {
  border: 1px solid #715454 !important;
}
.table > tbody > tr > td,
.table > tbody > tr > th,
.table > tfoot > tr > td,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > thead > tr > th {
  padding: 0px !important;
}

.modal fade show d-block {
  background: none;
}

/*Now the CSS*/
* {
  margin-bottom: 0;
  margin-left: 0;
  margin-right: 0;
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0;
}

.tree ul {
  padding-top: 15px;
  position: relative;
  margin-left: -2px !important;
  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
}

.tree li {
  float: left;
  text-align: center;
  list-style-type: none;
  position: relative;
  padding: 15px 0px 0 3px;
  margin-top: 0px !important;
  margin-bottom: 10px !important;
  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
}

/*We will use ::before and ::after to draw the connectors*/

.tree li::before,
.tree li::after {
  content: "";
  position: absolute;
  top: 0;
  right: 50%;
  border-top: 1px solid #ccc;
  width: 50%;
  height: 15px;
}
.tree li::after {
  right: 50%;
  left: 50%;
  border-left: 1px solid #ccc;
}

/*We need to remove left-right connectors from elements without 
any siblings*/
.tree li:only-child::after,
.tree li:only-child::before {
  display: none;
}

/*Remove space from the top of single children*/
.tree li:only-child {
  padding-top: 0;
}

/*Remove left connector from first child and 
right connector from last child*/
.tree li:first-child::before,
.tree li:last-child::after {
  border: 0 none;
}
/*Adding back the vertical connector to the last nodes*/
.tree li:last-child::before {
  border-right: 1px solid #ccc;
  border-radius: 0 5px 0 0;
  -webkit-border-radius: 0 5px 0 0;
  -moz-border-radius: 0 5px 0 0;
}
.tree li:first-child::after {
  border-radius: 5px 0 0 0;
  -webkit-border-radius: 5px 0 0 0;
  -moz-border-radius: 5px 0 0 0;
}

/*Time to add downward connectors from parents*/
.tree ul ul::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  border-left: 1px solid #ccc;
  width: 0;
  height: 15px;
}

.tree li a {
  background: whiteSmoke;
  border: 1px solid #ccc;
  padding: 5px 10px;
  text-decoration: none;
  color: #000;
  font-family: arial, verdana, tahoma;
  font-size: 11px;
  display: inline-block;

  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;

  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
}

/*Time for some hover effects*/
/*We will apply the hover effect the the lineage of the element also*/
.tree li a:hover,
.tree li a:hover + ul li a {
  background: yellow;
  color: #000;
  cursor: pointer;

  border: 1px solid #94a0b4;
}
/*Connector styles on hover*/
.tree li a + ul li::after,
.tree li a + ul li::before,
.tree li a + ul::before,
.tree li a + ul ul::before {
  border-color: #94a0b4;
}

/*Thats all. I hope you enjoyed it.
Thanks :)*/
</style>



// WEBPACK FOOTER //
// dashboardReports.vue?d80d53e2